import { IGatsbyImageData } from 'gatsby-plugin-image';
import {
  PROVIOTICS_HEADERICON1_SVG,
  PROVIOTICS_HEADERICON2_SVG,
  PROVIOTICS_HEADERICON3_SVG,
  PROVIOTICS_JAR_SVG,
  PROVIOTICS_MAILER_SVG,
  PROVIOTICS_REFILL_SVG
} from '@constants';
import ComparisonBackgroundImage from '@images/proviotics/comparison-background.png';
import ProvioticsJarImage from '@images/proviotics/proViotics-jar-front-with-pills.png';
import ProvioticsInHandImage from '@images/proviotics/proViotics_in_hand.png';

export interface VaginalFloraData {
  title: string;
  text: string;
  imageUrl: string;
}

export interface IconsBoxData {
  title: string;
  iconsWithText: {
    icon: string;
    text: string;
  }[];
}

export interface ZeroWasteData {
  title: string;
  text: string;
  iconBoxes: IconsBoxData[];
}

export interface BackedByScienceData {
  title: string;
  text: string;
  image: string;
}

export interface ProvioticsTableData {
  title: string;
  tableImg: string;
  tableImgLg: string;
  secondImageUrl: string;
  backgroundImage: string;
}

export interface IconWithBottomTextData {
  iconUrl: string;
  text: string;
}

export interface FreeFromNastiesData {
  title: string;
  text: string;
  iconsWithBottomText: IconWithBottomTextData[];
}

export interface EnhanceData {
  imageUrl: string;
  title: string;
  text: string;
}

export interface ProvioticsTriggerData {
  text: string;
  icon: string;
  onClick: () => void | boolean;
}

export interface ImageAndTextRowData {
  link: { text: string };
  image: {
    alt?: string;
    url: string;
    gatsbyImageData: IGatsbyImageData;
  };
  text: { text: string };
}

export interface MicrobiomeData {
  title: string;
  text: string;
  imageRows: ImageAndTextRowData[];
}

export interface ProvioticsHeaderData {
  imageUrl: string;
  title: string;
  subtitle: string;
  text: string;
  iconRows: {
    icon: string;
    text: string;
  }[];
  buyingOptions: {
    type: string;
    text: string;
    price: string;
  }[];
}

export interface SlidableQuotesData {
  backgroundRight: { browser: string; mobile: string };
  backgroundLeft: { browser: string; mobile: string };
  quotes: { text: string; name: string }[];
}

export const getProvioticsData = () => ({
  zeroWaste: {
    title: 'Zero waste vaginal care',
    text: 'Every part of our ProViotics product can either be reused, or naturally decomposed. It comes complete with an organic cotton pouch and a compostable refill pouch - reducing waste and emissions with every cycle.',
    iconBoxes: [
      {
        title: 'Initiation box',
        iconsWithText: [
          {
            text: 'Aluminium Jar',
            icon: PROVIOTICS_JAR_SVG
          },
          {
            text: 'Cardboard Box & Mailer',
            icon: PROVIOTICS_MAILER_SVG
          }
        ]
      },
      {
        title: 'Refill',
        iconsWithText: [
          {
            text: 'Compostable Refill Pouch',
            icon: PROVIOTICS_REFILL_SVG
          },
          {
            text: 'Cardboard Box & Mailer',
            icon: PROVIOTICS_MAILER_SVG
          }
        ]
      }
    ]
  },
  comparisonTableData: {
    title: 'Daye ProViotics vs. other probiotics',
    secondImageUrl: ProvioticsInHandImage,
    backgroundImage: ComparisonBackgroundImage
  },
  provioticsHeaderData: {
    imageUrl: ProvioticsJarImage,
    title: 'ProViotics',
    subtitle: 'Boost your microbiome',
    text: 'ProViotics help protect your vagina from infections like thrush and BV, while strengthening your gut health.',
    iconRows: [
      {
        icon: PROVIOTICS_HEADERICON1_SVG,
        text: 'Vegan'
      },
      {
        icon: PROVIOTICS_HEADERICON2_SVG,
        text: 'Alergen Free'
      },
      {
        icon: PROVIOTICS_HEADERICON3_SVG,
        text: 'Reusable Packaging'
      }
    ],
    buyingOptions: [
      {
        type: 'one-off',
        text: 'Buy one-off',
        price: '€33.00'
      },
      {
        type: 'subscription',
        text: 'Subscribe & save',
        price: '€27.50/mo'
      }
    ]
  }
});
